//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    payListType: {
      type: Array,
      required: false,
    }
  },
  watch: {
    payListType: {
      handler() {
        var typelist  = []
        if(this.payListType.length==0){
          typelist =  this.defaultPayList
        }else{
          typelist = this.payListType
        }
        this.payList = [];
        for (let i = 0; i < typelist.length; i++) {
          for (let j = 0; j < this.list.length; j++) {
            if (typelist[i] == this.list[j].pay) {
              this.payList.push(this.list[j]);
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      close: require("@/assets/image/icon/close_btn.png"),
      arrow: require("@/assets/image/icon/arrow.png"),
      payList: [],
      defaultPayList: ["CC","alipay","wechat"],
      list: [
        {
          name: this.$t("RECHARGE_LANG.selectPay.3"),
          icon: require("@/assets/image/icon/ali.png"),
          pay: "alipay"
        },
        {
          name: this.$t("RECHARGE_LANG.selectPay.4"),
          icon: require("@/assets/image/icon/wachat.png"),
          pay: "wechat"
        },
        {
          name: this.$t("RECHARGE_LANG.selectPay.5"),
          icon: require("@/assets/image/icon/visa.png"),
          pay: "CC"
        },
        {
          name: this.$t("RECHARGE_LANG.selectPay.5"),
          icon: require("@/assets/image/icon/visa.png"),
          pay: "visa"
        },
        {
          name: this.$t("RECHARGE_LANG.selectPay.5"),
          icon: require("@/assets/image/icon/visa.png"),
          pay: "mastercard"
        },
        {
          name: this.$t("RECHARGE_LANG.selectPay.6"),
          icon: require("@/assets/image/icon/googlePay.png"),
          pay: "googlePay"
        },
        {
          name: this.$t("RECHARGE_LANG.selectPay.7"),
          icon: require("@/assets/image/icon/huawei_pay.png"),
          pay: "huawei"
        }
      ]
    };
  },
  methods: {
    closeSelectPayDialog() {
      this.$emit("onClose", false);
      this.isShow = false;
    },
    selectPay(e) {
      this.$emit("onConfirm", e);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/base/selectPayDialog.vue